import { render } from "./InsertArticle.vue?vue&type=template&id=7178e1d8"
import script from "./InsertArticle.vue?vue&type=script&lang=js"
export * from "./InsertArticle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__